import { icons } from '@ublend-npm/aulaui-next';

import { hotkeys } from '../../config/hotkeys';
import { RichTextCommand } from './types';
import { isCurrentHeading } from '../headings/headings';
import {
  Bold,
  InlineCode,
  Italic,
  StrikeThrough,
  Underline,
  Colour,
} from '../../components/RichText';
import { isCurrentBlockQuote } from '../blockQuote/blockQuote';

export const richTextCommandsGroup1: RichTextCommand[] = [
  {
    label: 'Bold',
    icon: icons.FormatBold,
    richTextMark: 'b',
    renderLeaf: Bold,
    hotkeys: hotkeys.bold,
    disabled: isCurrentHeading,
  },
  {
    label: 'Italic',
    icon: icons.FormatItalic,
    richTextMark: 'i',
    renderLeaf: Italic,
    hotkeys: hotkeys.italic,
    disabled: isCurrentBlockQuote,
  },
  {
    label: 'Underlined',
    icon: icons.FormatUnderlined,
    richTextMark: 'u',
    renderLeaf: Underline,
    hotkeys: hotkeys.underlined,
    disabled: () => false,
  },
  {
    label: 'Strikethrough',
    icon: icons.FormatStrikethrough,
    richTextMark: 's',
    renderLeaf: StrikeThrough,
    hotkeys: hotkeys.strikethrough,
    disabled: () => false,
  },
];

export const richTextCommandsGroup2: RichTextCommand[] = [
  {
    label: 'Inline code',
    icon: icons.Code,
    richTextMark: 'e',
    renderLeaf: InlineCode,
    hotkeys: hotkeys.inlineCode,
    disabled: () => false,
  },
];

export const textColourCommand: RichTextCommand = {
  label: 'Font colour',
  icon: icons.FontColor,
  richTextMark: 'c',
  renderLeaf: Colour,
  hotkeys: hotkeys.fontColour,
  disabled: () => false,
};

export const richTextCommands = [
  ...richTextCommandsGroup1,
  ...richTextCommandsGroup2,
  textColourCommand,
];
